import EmailForm from './EmailForm';
import ExternalLink from '@/components/elements/ExternalLink';

export default function EmailSubscribe({ block, position }) {
  const { description, background_color, privacy_policy_link, _metadata } =
    block.email_subscribe;

  return (
    <section
      id={`${_metadata?.uid ?? 'email-subscribe'}_${position}`}
      data-name={'email-subscribe'}
      className={`bg-warm-pewter-20 px-5 py-30 sm:px-30 bg-[${background_color}]`}
    >
      <div className="mx-auto grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div className="h4 sm:h3 lg:max-w-145 lg:justify-self-end">
          <h2 className="inline sm:block lg:inline xl:block">{description}</h2>
        </div>
        <div>
          <EmailForm />
          <p className="body-s text-dark-grey-text mt-4">
            We care about your data. Read our{' '}
            {privacy_policy_link[0] && (
              <ExternalLink
                linkText="privacy&nbsp;policy"
                internalLink={privacy_policy_link[0]?.url}
                linkStyling="underline"
              />
            )}
            .
          </p>
        </div>
      </div>
    </section>
  );
}
